<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card v-if="UserInfo.role_id < 10000">
        <md-card-content>
          <!-- 卡片主体(表单) -->
          <div class="md-layout card-form" style="max-width: 600px;">
            <div class="md-layout-item md-size-40 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label>{{$I18n("type")}}</label>
                <md-select v-model="formData.type">
                  <md-option :value="'sms'">{{$I18n('sms')}}</md-option>
                  <md-option :value="'email'">{{$I18n('email')}}</md-option>
                  <md-option :value="'voice'">{{$I18n('simple_phone')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout md-layout-item md-size-20">
              <div class="md-layout-item md-size-25">
                <md-button class= "left-icon md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_setting")}}</add-button>
          <!-- 卡片主体(表格) -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sys')">{{ item.app_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('category')">{{ item.category_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">    {{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('platform_name')">{{ item.plat ?item.plat.name :"" }}</md-table-cell>
              <md-table-cell :md-label="$I18n('template_name')">{{ item.temp ?item.temp.name :""  }}</md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop="table_editItem(item)"
                  class="md-just-icon md-round md-info"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  @click.stop="table_deleteItem(item)"
                  class="md-just-icon md-round md-danger md-info left-icon"
                  ><md-icon>close</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 翻页 -->
          <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref="modal" 
      :title="modalTitle" 
      :right="openModalType!=='delete'" 
      @submit="modal_submit" 
      :large="openModalType==='import'" 
      :submitBtn="openModalType !=='import'"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", '')}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString1000 } from "@/common/tools.js";
export default {
  props: ["userinfo_sys"],
  data() {
    return {
      total   : 0,
      pageSize: 10,
      pageNo  : 1,
      bindData: [],
      temp    : [],
      plat    : [],
      // 表格相关
      ...({
        formData:{
          type: "email",
        },
        searchData : {
          type: 2,
        },
        // 弹窗相关
        openModal     : false,  // 是否打开弹窗
        openModalType : "upload", // 弹窗类型
        modalTitle    : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      ...({
        modalData : new FormClass({
          app_id : "",
          platform_id : "",
          template_id : "",
        }),
      }),
    };
  },
  mounted : function() {
    this.getPack();
  },
  methods: {
    getPack(){
      return this.api_getTemp()
        .then(() => {return this.api_getPlat()})
        .then(this.api_getPageData);
    },
    // 获取绑定
    api_getPageData(){
      return this.$api.getVoiceAppBind({
        type     : this.searchData.type,
        link_id  : this.userinfo_sys,
        link_type: 2,
        page_no  : 1,
        page_size: 9999, 
      })
        .then(this.$Then(res => {
          this.bindData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.bindData = [];
        }));
    },
    // 获取模板
    api_getTemp(){
      return this.$api.getVoiceTemplate(this.searchData)
        .then(this.$Then(res => {
          this.temp = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.temp = [];
        }));
    },
    // 获取平台
    api_getPlat(){
      return this.$api.getVoicePlatform(this.searchData)
        .then(this.$Then(res => {
          this.plat = res.data
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.plat = [];
        }));
    },
    // 重新查询
    form_changeSearchData(){
      // this.searchData = {type: 0}
      if(this.formData.type == "sms") {
        this.searchData.type = 3;
      } else if (this.formData.type === "email") {
        this.searchData.type = 2;
      } else if (this.formData.type === "voice"){
        this.searchData.type = 4;
      }
      this.pageNo = 1;
      this.getPack();
    },
    table_addItem(){
      if(this.plat.length === 0 || this.temp.length === 0){
        this.$errorMsg(this.$I18n("none_plat_temp"));
        return
      }
      this.modalTitle = this.$I18n("add");
      this.modalData.Update({
        app_id : this.userinfo_sys,
        platform_id : this.plat[0].id,
        template_id : this.temp[0].id,
      });
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.Update({
        ...item,
      });
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update({...item});
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.$refs.modal.close();
    },
    // 提交表单
    modal_submit () {
      let sendData = {
        id        : this.modalData.Form.id,
        link_type : 2,
        link_id   : this.modalData.Form.app_id,
        platform_id : this.modalData.Form.platform_id,
        template_id : this.modalData.Form.template_id,
      }
      sendData.type = this.searchData.type;

      let apiPOST = new Promise(() => {});
      if(this.openModalType === "add"){
        apiPOST = this.$api.addVoiceAppBind(sendData);
      } else if (this.openModalType === "edit"){
        apiPOST = this.$api.editVoiceAppBind(sendData);
      } else if (this.openModalType === "delete"){
        apiPOST = this.$api.delVoiceAppBind(sendData);
      }
      apiPOST
        .then(this.$Then(res => {
          if(res.code === 6001){
            this.$errorMsg(this.$I18n("pls_check_verify_3"));
            return
          }
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
          this.api_getPageData();
        }), [6001])
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.bindData || this.bindData.length === 0){
        return [];
      } else {
        return [...this.bindData]
          .map((item , index) => {
            const category_list = ["net_type_0", "system", "the_pay", "alarm"];
            var type_name = "";
            if(item.template && item.template.mode){
              if(item.template.mode == 1){
                type_name = this.$I18n("tmp_type_"+ item.template.notify_type);
              } else if(item.template.mode == 2){
                type_name = this.$I18n(this.$Param.noticeTempType.getName(item.template.notify_type));
              } else if(item.template.mode == 3){
                type_name = this.$I18n(this.$Param.alarmType.getName(item.template.notify_type, "all"));
              }
            }
            return {
              index,
              app_id: item.link_id,
              category_name : (item.template && item.template.mode) ?this.$I18n(category_list[item.template.mode]) : this.$I18n("net_type_0"),
              type_name     : type_name,
              create_time:  timestampToString1000(item.gmt_create),
              temp : this.temp.filter(titem => titem.id === item.template_id)[0],
              plat : this.plat.filter(pitem => pitem.id === item.platform_id)[0],
              ... item,
            }
          })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("platform"),
          keys    : "platform_id",
          type    : "select",
          options : this.plat.map(i => {
            return {
              id  : i.id,
              name: i.name,
            }
          }),
          required: true,
        },{
          label   : this.$I18n("frame"),
          keys    : "template_id",
          type    : "select",
          options : this.temp.map(i => {
            return {
              id  : i.id,
              name: i.name,
            }
          }),
          required: true,
        }
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>